import axios from 'axios';

// Função para testar a autenticação diretamente
export const testAuthDirectly = async (username, password) => {
  try {
    // URLs para tentar
    const urls = [
      'http://localhost:3003/proxy/api/auth/login',  // URL do proxy local
      'http://26.0.250.179:3002/api/auth/login',  // URL da rede Radmin VPN
      'https://floratta.tecnett.com/api/auth/login', // URL da Hostinger
      './api/auth/login', // URL relativa
      '/api/auth/login', // URL relativa alternativa
    ];
    
    const results = [];
    
    // Tentar cada URL
    for (const url of urls) {
      try {
        console.log(`Tentando autenticar em ${url} com usuário: ${username}`);
        
        const response = await axios.post(url, { username, password }, {
          headers: {
            'Content-Type': 'application/json'
          },
          timeout: 5000 // Timeout de 5 segundos
        });
        
        console.log(`Sucesso em ${url}:`, response.data);
        results.push({ url, success: true, data: response.data });
      } catch (error) {
        console.error(`Erro em ${url}:`, error.message);
        results.push({ 
          url, 
          success: false, 
          error: error.message,
          status: error.response?.status,
          data: error.response?.data
        });
      }
    }
    
    return results;
  } catch (error) {
    console.error('Erro geral:', error);
    return [{ success: false, error: error.message }];
  }
};

// Função para adicionar ao window para testes no console
if (typeof window !== 'undefined') {
  window.testAuth = async (username = 'admin', password = 'admin123') => {
    const results = await testAuthDirectly(username, password);
    console.table(results.map(r => ({ 
      url: r.url, 
      success: r.success, 
      status: r.status || (r.success ? 200 : 'N/A'),
      message: r.success ? 'OK' : (r.data?.error || r.error)
    })));
    return results;
  };
}

export default testAuthDirectly;
